module.exports = __webpack_public_path__ + "img/mlt_newag.01469d89.jpg";